import { getBaseUrl } from '@databases/database-state';
import React, { type FunctionComponent } from 'react';

import AbstractLink from './AbstractLink';

export interface ContentLinkProps {
  contentId: string;
  noFocus?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  onFocus?: (e: React.FocusEvent) => void;
  showDisabledValue?: boolean;
}

/**
 * Renders a formatted placeholder representing a page reference. The page reference is resolved
 * automatically to retrieve the page URL. Until the page reference is resolved, the page title is
 * shown as plain text, once it is resolved, it is converted into a link to the page.
 */
const ContentLink: FunctionComponent<ContentLinkProps> = ({
  contentId,
  noFocus,
  onClick,
  onFocus,
  showDisabledValue,
}) => {
  const baseUrl = getBaseUrl();

  return (
    <AbstractLink
      href={`${baseUrl}/spaces/~/pages/${contentId}`}
      onClick={onClick}
      onFocus={onFocus}
      noFocus={noFocus}
      useSmartLink
      showDisabledValue={showDisabledValue}
    />
  );
};

export default ContentLink;
